/// <reference path="../../svg.d.ts" />
import React from 'react';
import { ItemPacking } from '@hero/schema';
import { getIconProps, IconProps } from '../../utils';
import PackageSvg from '../../assets/packing/package.svg?react';
import PalletSvg from '../../assets/packing/pallet.svg?react';
import BarrelSvg from '../../assets/packing/barrel.svg?react';
import OtherSvg from '../../assets/packing/other.svg?react';
import { cn } from '@hero/web-lib';

const customIconClassNames = 'w-6 h-6';

export const PackageIcon: React.FC<IconProps> = props => {
  return (
    <PackageSvg
      {...getIconProps({ ...props, className: cn(customIconClassNames, props.className) })}
    />
  );
};

export const PalletIcon: React.FC<IconProps> = props => {
  return (
    <PalletSvg
      {...getIconProps({ ...props, className: cn(customIconClassNames, props.className) })}
    />
  );
};

export const BarrelIcon: React.FC<IconProps> = props => {
  return (
    <BarrelSvg
      {...getIconProps({ ...props, className: cn(customIconClassNames, props.className) })}
    />
  );
};

// Bag Icon - using Other.svg as fallback since bag.svg doesn't exist
export const BagIcon: React.FC<IconProps> = props => {
  return (
    <OtherSvg
      {...getIconProps({ ...props, className: cn(customIconClassNames, props.className) })}
    />
  );
};

// Unpackable Item Icon - using Other.svg as fallback
export const UnpackableItemIcon: React.FC<IconProps> = props => {
  return (
    <OtherSvg
      {...getIconProps({ ...props, className: cn(customIconClassNames, props.className) })}
    />
  );
};

// Other Icon
export const OtherPackingIcon: React.FC<IconProps> = props => {
  return (
    <OtherSvg
      {...getIconProps({ ...props, className: cn(customIconClassNames, props.className) })}
    />
  );
};

export const PackingIconDynamic: React.FC<IconProps & { packing: ItemPacking }> = props => {
  const { packing, ...rest } = props;
  const IconComponent = getPackingIcon(packing);
  return <IconComponent {...rest} />;
};

// Helper function to get the appropriate packing icon component
function getPackingIcon(packingType: ItemPacking): React.FC<IconProps> {
  switch (packingType) {
    case 'pallet':
      return PalletIcon;
    case 'package':
      return PackageIcon;
    case 'barrel':
      return BarrelIcon;
    case 'bag':
      return BagIcon;
    case 'unpackable_item':
      return UnpackableItemIcon;
    case 'other':
      return OtherPackingIcon;
    default:
      return OtherPackingIcon;
  }
}
